export const itDefaultTranslations: Record<string, string> = {
  home: 'Home',
  navigate: 'Navigare',
  select_btn: 'Selezionare',
  subtitles: 'Sottotitoli',
  turn_off_subtitles: 'Disattiva',
  no_subtitles_available: 'Nessun sottotitolo disponibile',
  off: 'Spento',
  date: 'Data',
  description: 'Descrizione',
  charges: 'Importo',
};
